import { createAction, props } from '@ngrx/store';

export const loadWindowDetails = createAction(
  '[WindowDetail] Load WindowDetails'
);

export const setDocumentSize = createAction(
  '[WindowDetail] Set DocumentSize',
  props<{
    documentHeight:number
    documentWidth:number
  }>()
)

